import {
    SET_OBS_DOWN_PAYMENT,
    SET_OBS_TERM,
    SET_OBS_CREDIT,
    SET_SHOW_OBS,
    SET_OBS,
} from './constants';

export const setOBS = obs => ({
    type: SET_OBS,
    obs,
});

export const setOBSDownPayment = obsDownPayment => ({
    type: SET_OBS_DOWN_PAYMENT,
    obsDownPayment,
});

export const setOBSTerm = obsTerm => ({
    type: SET_OBS_TERM,
    obsTerm,
});

export const setOBSCredit = obsCredit => ({
    type: SET_OBS_CREDIT,
    obsCredit,
});

export const setShowOBS = showOBS => ({
    type: SET_SHOW_OBS,
    showOBS,
});



// WEBPACK FOOTER //
// ./src/containers/common/obs/actions.js